export default function printFilesize(bytes: number): string {
    const kilobytes = bytes / 1024;
    return `${Math.round(kilobytes)}kb`;
}
